// extracted by mini-css-extract-plugin
export default {"skills":"Skills_skills__n2t-S","tituloSecao":"Skills_tituloSecao__Gul-Z","grid":"Skills_grid__LDWdJ","card":"Skills_card__ZKiS9"};